import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/loading.gif'


const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = {
  key: 1,
  class: "withdraw"
}
const _hoisted_3 = { style: {"padding-top":"50px"} }
const _hoisted_4 = { class: "button-area" }

import { ref } from "vue";
import { useRouter } from "vue-router";
import CommonButton from "./CommonButton.vue";
import { UserInfoStore } from "../store/UserInfoStore";
import ComfirmDialog from "./ComfirmDialog.vue";
import liff from "@line/liff";


export default /*@__PURE__*/_defineComponent({
  __name: 'Withdrawal',
  setup(__props) {

const userInfoStore = UserInfoStore();
const loading = ref(false);

const router = useRouter();
const reason = ref("");
const showDialog = ref(false);
const message = ref("アカウント削除を実行します。\n本当によろしいですか？");
const button = ref("削除");
const dialog = ref<InstanceType<typeof ComfirmDialog>>();
const name = `アカウント名：${userInfoStore.userDetail.name}`;
const isWithdrawal = ref(false);
// 退会処理
async function withdrawal() {
  loading.value = true;
  const result = await userInfoStore.withdrawal(reason.value);

  if (result.result) {
    setTimeout(() => {
      liff.closeWindow();
    }, 1500);
    isWithdrawal.value = true;
    loading.value = false;
  } else {
    loading.value = false;
  }
}
const cancel = () => {
  router.back();
};
function confirm() {
  showDialog.value = true;
  dialog.value?.openDialog();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[5] || (_cache[5] = [
          _createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
        ])))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass([loading.value ? 'l-modal__bg' : ''])
    }, null, 2 /* CLASS */),
    (!isWithdrawal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", null, "アカウント名 : " + _toDisplayString(_unref(userInfoStore).userDetail.name), 1 /* TEXT */),
            _cache[6] || (_cache[6] = _createElementVNode("p", null, [
              _createTextVNode(" 一度退会するとアカウントの復元ができません。今までのデータは削除されます。"),
              _createElementVNode("br"),
              _createTextVNode(" ※進行中の案件がある場合など、退会処理の受付ができない場合があります。 ")
            ], -1 /* HOISTED */)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reason).value = $event)),
              class: "dialog-text-area",
              required: "",
              placeholder: "退会理由"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, reason.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(CommonButton, {
              data: {
          status: reason.value ? 0 : 2,
          button: `退会する`,
        },
              onClick: _cache[1] || (_cache[1] = ($event: any) => (reason.value ? confirm() : ''))
            }, null, 8 /* PROPS */, ["data"]),
            _createVNode(CommonButton, {
              data: {
          status: 3,
          button: `キャンセル`,
        },
              onClick: _cache[2] || (_cache[2] = ($event: any) => (cancel()))
            })
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(ComfirmDialog, {
      ref_key: "dialog",
      ref: dialog,
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showDialog).value = $event)),
      message: message.value,
      button: button.value,
      "sub-message": name,
      onApply: _cache[4] || (_cache[4] = ($event: any) => (withdrawal()))
    }, null, 8 /* PROPS */, ["modelValue", "message", "button"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})